export const map = {
	components: {
        imagesSlider: require('components/imagesSlider/imagesSlider'),
        contact: require('components/contact/contact'),
        textSlider: require('components/textSlider/textSlider'),
        popinVideoSlider: require('components/popinVideoSlider/popinVideoSlider'),
        menu: require('components/menu/menu'),
        textVideoBlock: require('components/textVideoBlock/textVideoBlock'),
		hero: require('components/hero/hero'),
	},
	pages: {
		homepage: {
			index: require('pages/homepage/homepage-index'),
		},
		contact: {
			index: require('pages/contact/contact-index'),
		},
		legals: {
			index: require('pages/legals/legals-index'),
		},
		nofound: {
			index: require('pages/nofound/nofound-index'),
		},
	},
};
